<template>
  <div class="container">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('class.back') }}</span>
    </div>
    <div class="header" v-if="list.length > 0">
      <div>
        <div class="title">{{ $t('class.title') }}</div>
        <a-button type="primary" @click="create">{{ $t('class.create') }}</a-button>
      </div>
    </div>
    <div class="content">
      <div v-if="list.length === 0" class="nodata">
        <img src="@/assets/img/bj_zanwu@2x.png" alt="" />
        <div>
          <div class="text">{{ $t('class.noClass') }}</div>
          <a-button type="primary" @click="create">{{ $t('class.create') }}</a-button>
        </div>
      </div>
      <div class="list" v-else>
        <a-table row-key="id" :locale="locale" :columns="columns" :data-source="list">
          <template slot="type" slot-scope="text">
            <span v-if="text === '1'">{{ $t('class.administrativeClass') }}</span>
            <span v-else>{{ $t('class.teachingClass') }}</span>
          </template>
          <template slot="operate" slot-scope="text, record">
            <div class="operate">
              <span @click="edit(record)">{{ $t('class.operations.edit') }}</span>
              <span @click="review(record)">{{ $t('class.operations.view') }}</span>
              <span @click="delModal(record.id)">{{ $t('class.operations.delete') }}</span>
            </div>
          </template>
        </a-table>
      </div>
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handleTableChange" />
    </div>
    <a-modal :title="editId ? $t('class.edit') : $t('class.create')" :visible="visible" @ok="ok" @cancel="visible = false">
      <a-form :form="form">
        <a-form-item :label="$t('class.form.name.label')" :colon="false">
          <a-input maxLength="10" v-decorator="['name', { rules: [{ required: true, message: $t('class.form.name.required') }] }]" :placeholder="$t('class.form.name.placeholder')" />
        </a-form-item>
      </a-form>
    </a-modal>
    <TipModal
      @ok="classDel"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('class.deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('class.deleteConfirm.content')}</p>`" />
  </div>
</template>

<script>
import { classList, classSave, classDel } from '@/api/lesson'
import { getListIndex } from '@/utils/other'
import NoData from '@/components/noData/index'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'

export default {
  components: {
    NoData,
    TipModal,
    Pagination
  },
  data() {
    return {
      locale: {
        emptyText: <NoData />
      },
      visible: false,
      editId: undefined,
      delId: undefined,
      delVisible: false,
      list: [],
      columns: [
        {
          title: this.$t('class.columns.index'),
          dataIndex: 'index',
          key: 'index',
          align: 'center'
        },
        {
          title: this.$t('class.columns.name'),
          dataIndex: 'name',
          key: 'name',
          align: 'center'
        },
        {
          title: this.$t('class.columns.studentCount'),
          dataIndex: 'studentNum',
          key: 'studentNum',
          align: 'center'
        },
        {
          title: this.$t('class.columns.createdAt'),
          dataIndex: 'createdAt',
          key: 'createdAt',
          align: 'center'
        },
        {
          title: this.$t('class.columns.operations'),
          dataIndex: 'operate',
          key: 'operate',
          align: 'center',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10,
        hideOnSinglePage: true
      },
      form: this.$form.createForm(this)
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    create() {
      this.visible = true
      this.editId = undefined
      this.form.setFieldsValue({
        name: undefined
      })
    },
    edit(obj) {
      this.editId = obj.id
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: obj.name
        })
        console.log(this.form.getFieldsValue())
      })
    },
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          classSave({
            id: this.editId,
            name: values.name,
            classType: '2'
          }).then(res => {
            if (res.code != 200) return
            this.visible = false
            this.$message.success(this.editId ? this.$t('class.message.editSuccess') : this.$t('class.message.createSuccess'))
            this.pagination.page = 1
            this.getClassList()
          })
        }
      })
    },
    delModal(id) {
      this.delId = id
      this.delVisible = true
    },
    classDel() {
      classDel({
        id: this.delId
      }).then(res => {
        if (res.code != 200) return
        this.delVisible = false
        this.$message.success(this.$t('class.message.deleteSuccess'))
        this.pagination.page = 1
        this.getClassList()
      })
    },
    review(record) {
      this.$router.push({
        name: 'studentList',
        query: {
          id: record.id,
          name: record.name,
          type: record.type
        }
      })
    },
    handleTableChange() {
      this.getClassList()
    },
    getClassList() {
      classList({
        page: this.pagination.page
      }).then(res => {
        this.list = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
        this.pagination.total = res.data.total
      })
    }
  },
  mounted() {
    this.getClassList()
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 18px 19px;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .header {
    margin-bottom: 22px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ededed;
    .title {
      font-size: 16px;
      font-weight: 800;
      color: #000000;
    }
    > div {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }
  }
  .content {
    position: relative;
    height: calc(100% - 48px - 22px - 34px - 25px - 30px);
    .nodata {
      height: 100%;
      display: flex;
      align-items: center;
      padding-bottom: 70px;
      flex-direction: column;
      justify-content: center;
      img {
        width: 285px;
        margin-bottom: 12px;
      }
      > div {
        width: 100%;
        display: flex;
        margin-top: -70px;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .text {
          font-weight: 550;
          color: #0d2340;
          margin-bottom: 12px;
        }
      }
    }
    .list {
      height: 100%;
      overflow-y: auto;
      padding-bottom: 20px;
    }
    .list-pagination {
      width: 100%;
      bottom: 15px;
      position: absolute;
    }
  }
}
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 22px;
    .ant-input {
      height: 35px;
    }
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
/deep/.ant-modal {
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-input {
    color: #000000;
  }
}
</style>
